import { render, staticRenderFns } from "./EditApp.page.vue?vue&type=template&id=2e869741&"
import script from "./EditApp.page.vue?vue&type=script&lang=js&"
export * from "./EditApp.page.vue?vue&type=script&lang=js&"
import style0 from "./EditApp.page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports